/** Cronómetro de cocina: tiempo desde aceptación vs. ETA (colores progresivos). */

/** Estados donde el cronómetro sigue en vivo (solo cocina activa). */
export const KITCHEN_STATUSES = new Set(['accepted', 'preparing']);

/** Estados terminales o posteriores a cocina: no cuenta en vivo. */
export const KITCHEN_TIMER_STOP_STATUSES = new Set([
  'awaiting_extras',
  'ready',
  'dispatched',
  'delivered',
  'cancelled',
  'rejected',
]);

export function formatElapsed(ms) {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function kitchenTimerStart(order) {
  if (order?.accepted_at) return order.accepted_at;
  if (KITCHEN_STATUSES.has(order?.status) && order?.updated_at) return order.updated_at;
  return null;
}

export function shouldShowKitchenTimer(order) {
  const status = String(order?.status || '');
  if (KITCHEN_TIMER_STOP_STATUSES.has(status)) return false;
  const paymentOk =
    order?.payment_status === 'paid'
    || order?.payment_method === 'cash_on_delivery'
    || order?.payment_method === 'store_cash';
  if (!paymentOk) return false;
  return KITCHEN_STATUSES.has(status);
}

/** Hora en que dejó de contar el cronómetro de cocina (para mostrar tiempo congelado). */
export function kitchenTimerEndIso(order) {
  const candidates = [
    order?.kitchen_attended_at,
    order?.ready_at,
    order?.dispatched_at,
    order?.delivered_at,
  ];
  for (const iso of candidates) {
    if (iso && !Number.isNaN(Date.parse(iso))) return iso;
  }
  const status = String(order?.status || '');
  if (KITCHEN_TIMER_STOP_STATUSES.has(status) && order?.updated_at) {
    return order.updated_at;
  }
  return null;
}

/** Color del cronómetro según avance vs. hora ETA (mitad = ámbar, cerca/pasada ETA = rojo). */
export function kitchenTimerTone(elapsedMs, budgetMs) {
  if (!budgetMs || budgetMs <= 0) {
    const minutes = elapsedMs / 60000;
    if (minutes >= 45) return 'bg-red-100 text-red-800 border-red-200';
    if (minutes >= 30) return 'bg-amber-100 text-amber-900 border-amber-200';
    return 'bg-emerald-50 text-emerald-900 border-emerald-200';
  }

  const ratio = elapsedMs / budgetMs;
  if (ratio < 0.5) {
    return 'bg-emerald-50 text-emerald-900 border-emerald-200';
  }
  if (ratio >= 1) {
    return 'bg-red-200 text-red-950 border-red-400';
  }

  const t = (ratio - 0.5) / 0.5;
  if (t < 0.34) return 'bg-amber-50 text-amber-900 border-amber-200';
  if (t < 0.67) return 'bg-orange-100 text-orange-900 border-orange-300';
  return 'bg-red-100 text-red-800 border-red-300';
}

export function kitchenTimerBudgetMs(order, startMs) {
  const etaMs = order?.estimated_ready_at ? Date.parse(order.estimated_ready_at) : NaN;
  if (!Number.isNaN(etaMs) && etaMs > startMs) {
    return etaMs - startMs;
  }
  return 30 * 60_000;
}
